import { Box } from '@mui/material';
import { ApprovalWorkflowRoutes } from 'routing/approval-workflow-routes';
import { ApprovalWorkflowNavigationHeader } from './approval-workflow-navigation-header';

export function ApprovalWorkflowPage() {
  return (
    <>
      <ApprovalWorkflowNavigationHeader />
      <Box padding={2}>
        <ApprovalWorkflowRoutes />
      </Box>
    </>
  );
}
